// React / Next
import { createFileRoute } from '@tanstack/react-router';

// Components
import { PartnerPage } from '../pages/PartnerPage/PartnerPage';

export const Route = createFileRoute('/partner')({
  component: PartnerPage,
});
